import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { queryFeedBackExamineRecord } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '反馈人员',
      dataIndex: 'feedbackUser',
      align: 'center',
      width: 150,
      scopedSlots: {
        customRender: 'feedbackUser'
      }
    }, {
      title: '当前环节',
      dataIndex: 'appendName',
      align: 'center',
      width: 120
    }, {
      title: '反馈时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 100
    }, {
      title: '审核状态',
      dataIndex: 'auditStatus',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'auditStatus'
      }
    }, {
      title: '审核时间',
      dataIndex: 'auditDate',
      ellipsis: true,
      align: 'center',
      width: 100
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      columns: columns,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      where: {
        fillId: '',
        status: '',
        query: ''
      },
      data: [],
      pagination: this.$hdk.page()
    };
  },
  created: function created() {
    var fetch = this.fetch;
    fetch();
  },
  methods: {
    /*
     * 根据条件搜索通知公告
     */
    fetch: function fetch(options) {
      var _this = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (!pager.where) {
        pager.where = where;
      }
      // 赋值公告id
      pager.where.fillId = this.record.id;
      queryFeedBackExamineRecord(pager.current, pager.pageSize, pager.where).then(function (res) {
        _this.data = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(where, pager.where);
      }).finally(function () {
        _this.loading = false;
      });
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /**
     * 打开查看
     */
    view: function view(row) {
      this.$router.push({
        path: '/docNotice/notice/feedAuditOper',
        query: {
          fillId: row.fillId,
          id: row.id,
          // 反馈id
          type: 1
        }
      });
    },
    /**
     * 打开审核
     */
    audit: function audit(row) {
      this.$router.push({
        path: '/docNotice/notice/feedAuditOper',
        query: {
          fillId: row.fillId,
          id: row.id,
          // 反馈id
          type: 2
        }
      });
    }
  },
  props: {
    record: {
      type: Object,
      default: function _default() {}
    }
  }
};